import type { SVGProps } from 'react';

export default function CommandIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' stroke='#94A3B8' {...props}>
      <path
        d='M11.6667 3.93742C11.6667 4.82338 10.9485 5.54159 10.0625 5.54159H3.93754C3.05158 5.54159 2.33337 4.82338 2.33337 3.93742C2.33337 3.05146 3.05158 2.33325 3.93754 2.33325C4.8235 2.33325 5.54171 3.05146 5.54171 3.93742V10.0624C5.54171 10.9484 4.8235 11.6666 3.93754 11.6666C3.05158 11.6666 2.33337 10.9484 2.33337 10.0624C2.33337 9.17646 3.05158 8.45825 3.93754 8.45825H10.0625C10.9485 8.45825 11.6667 9.17646 11.6667 10.0624C11.6667 10.9484 10.9485 11.6666 10.0625 11.6666C9.17658 11.6666 8.45837 10.9484 8.45837 10.0624V3.93742C8.45837 3.05146 9.17658 2.33325 10.0625 2.33325C10.9485 2.33325 11.6667 3.05146 11.6667 3.93742Z'
        strokeLinejoin='round'
      />
    </svg>
  );
}

CommandIcon.displayName = 'CommandIcon';
